import React, { useState, useContext, useEffect } from 'react';
import { MainContext } from '../../../App';
import { CharlyChatContext } from '../CharlyChat';
import useDeleteChat from '../../../hooks/useDeleteChat';

function ModalDeleteChat() {
  const {setShow, setShowSpinner, setSpinnerText, chatToDeleteId, setChatToDeleteId, setChatSearchData, setChatId, setMessages} = useContext(CharlyChatContext);
  const {userId, amountPerPage} = useContext(MainContext);

  let [deleteChatTriggered, setDeleteChatTriggered] = useState(false);
  let [deleteChatData, setDeleteChatData] = useState({})
  let deleteChat = useDeleteChat(deleteChatTriggered, deleteChatData)

  function handleDeleteForm(e) {
    e.preventDefault();
    setShowSpinner(true);
    setSpinnerText("Chat aan het verwijderen");
    let chatToDelete = {
      "chat": {
        "id": chatToDeleteId,
        "userId": userId
      }
    }
    setDeleteChatData(chatToDelete);
    setDeleteChatTriggered(true);
  }

  useEffect(() => {
    if(deleteChat){
      if(deleteChat.status === 200) {
        setShow(false);
        setChatSearchData({});
        let chatData = {
          UserId: userId,
          CurrentPage: 1,
          AmountPerPage: amountPerPage,
          ReloadData: new Date()
        };

        setChatToDeleteId(0);
        setChatSearchData(chatData);
        setChatId('new');
        setMessages([]);
      }
      setDeleteChatTriggered(false);
      setSpinnerText("");
      setShowSpinner(false);
    }
  }, [deleteChat])

  return (
    <>
      <form className='delivery-form' onSubmit={(e) => handleDeleteForm(e)}>
        <div className='form-row'>
          <div className='col-12'>
            <h6>Weet je zeker dat je deze chat wilt verwijderen?</h6>
          </div>
        </div>
        <div className='form-row modal-btns'>
          <div className='col-6 offset-6'>
            <button className='btn secondary'>Chat verwijderen</button>
          </div>
        </div>
      </form>
    </>
  )
}

export default ModalDeleteChat;
